import React from 'react';
import Icons from 'assets/images/Icons';

const DownloadRewards = () => (
  <button className='primary big'><Icons name='Download' /></button>
);

export default DownloadRewards;